import Dict from '@/utils/dict-utils'

// 流程
export const stepDict = new Dict({
  PROJECT: { label: '验收项目', value: 1, index: 1 },
  PROGRAMME: { label: '验收方案', value: 2, index: 2 },
  TASK: { label: '验收任务', value: 3, index: 3 },
  COMMENT: { label: '成果评价', value: 4, index: 4 }
})

// 履约验收待办
export const performanceTodoDict = new Dict({
  // 采购人工作台
  12: { // 完成
    label: '【验收项目】项目审核',
    btnLabel: '去审核',
    value: 12,
    transitRouterName: 'LandlordProjectCheck', // 中转路由
    targetRouterName: 'CheckLandlordProject', // 目标路由
    needOrderId: true
  },
  22: { // 完成
    label: '【验收方案】方案制定',
    btnLabel: '去处理',
    value: 22,
    transitRouterName: 'LandlordProject', // 中转路由
    targetRouterName: 'LandlordProgrammeForm', // 目标路由
    needOrderId: true
  },
  23: { // 完成
    label: '【验收方案】方案审核',
    btnLabel: '去审核',
    value: 23,
    transitRouterName: 'LandlordProject', // 中转路由
    targetRouterName: 'LandlordProgrammeCheck', // 目标路由
    needOrderId: true
  },
  33: { // 完成
    label: '【验收任务】任务审核',
    btnLabel: '去审核',
    value: 33,
    transitRouterName: 'LandlordProject', // 中转路由
    targetRouterName: 'LandlordTaskCheck', // 目标路由
    needOrderId: true
  },
  36: { // 完成
    label: '【验收任务】任务验收',
    btnLabel: '去处理',
    value: 36,
    transitRouterName: 'LandlordProject', // 中转路由
    targetRouterName: 'LandlordTaskCheck', // 目标路由
    needOrderId: true
  },
  38: { // 完成
    label: '【验收任务】整合验收结果', // 验收任务 履约验收中
    btnLabel: '整合验收结果',
    value: 38,
    transitRouterName: 'LandlordProject', // 中转路由
    targetRouterName: 'LandlordTaskCheck', // 目标路由
    needOrderId: true
  },
  41: { // 完成
    label: '【验收任务】整改审核',
    btnLabel: '去审核',
    value: 41,
    transitRouterName: 'LandlordProject', // 中转路由
    targetRouterName: 'LandlordTaskCheck', // 目标路由
    needOrderId: true
  },
  43: { // 完成
    label: '【验收任务】验收结算归档',
    btnLabel: '去处理',
    value: 43,
    transitRouterName: 'LandlordProject', // 中转路由
    targetRouterName: 'LandlordTaskCheck', // 目标路由
    needOrderId: true
  },

  // 代理机构工作台
  13: { // 完成
    label: '【验收任务】履约委托',
    btnLabel: '接受委托',
    value: 13,
    transitRouterName: 'AgentEntrust', // 中转路由
    targetRouterName: 'AgentEntrust', // 目标路由
    needOrderId: false
  }, // 直接跳转至列表页
  21: { // 完成
    label: '【验收方案】方案制定',
    btnLabel: '去处理',
    value: 21,
    transitRouterName: 'AgentProject', // 中转路由
    targetRouterName: 'AgentProgrammeForm', // 目标路由
    needOrderId: true
  }, // 代理机构详情
  32: { // 完成
    label: '【验收任务】任务审核',
    btnLabel: '去审核',
    value: 32,
    transitRouterName: 'AgentProject', // 中转路由
    targetRouterName: 'AgentTaskCheck', // 目标路由
    needOrderId: true
  }, // 审核详情
  34: { // 完成
    label: '【验收任务】组建专家小组',
    btnLabel: '去处理',
    value: 34,
    transitRouterName: 'AgentProject', // 中转路由
    targetRouterName: 'AgentTaskCheck', // 目标路由
    needOrderId: true
  },
  35: {
    label: '【验收任务】任务验收',
    btnLabel: '去处理',
    value: 35,
    transitRouterName: 'AgentProject', // 中转路由
    targetRouterName: 'AgentTaskCheck', // 目标路由
    needOrderId: true
  },
  37: {
    label: '【验收任务】整合验收结果', // 验收任务 履约验收中
    btnLabel: '整合验收结果',
    value: 37,
    transitRouterName: 'AgentProject', // 中转路由
    targetRouterName: 'AgentTaskCheck', // 目标路由
    needOrderId: true
  },
  40: {
    label: '【验收任务】整改审核',
    btnLabel: '去审核',
    value: 40,
    transitRouterName: 'AgentProject', // 中转路由
    targetRouterName: 'AgentTaskCheck', // 目标路由
    needOrderId: true
  },
  42: {
    label: '【验收任务】验收结算归档',
    btnLabel: '去处理',
    value: 42,
    transitRouterName: 'AgentProject', // 中转路由
    targetRouterName: 'AgentTaskCheck', // 目标路由
    needOrderId: true
  },

  // 供应商工作台
  11: { // 完成
    label: '【验收项目】发起项目验收',
    btnLabel: '前往发起',
    value: 11,
    transitRouterName: 'SupplierProject', // 中转路由
    targetRouterName: 'SupplierProjectForm', // 目标路由
    needOrderId: true
  }, // 新建验收项目
  31: { // 完成
    label: '【验收任务】发起任务验收',
    btnLabel: '前往发起',
    value: 31,
    transitRouterName: 'SupplierProject', // 中转路由
    targetRouterName: 'SupplierTaskCheck', // 目标路由
    needOrderId: true
  }, // 详情
  39: { // 完成
    label: '【验收任务】发起任务整改验收',
    btnLabel: '前往处理',
    value: 39,
    transitRouterName: 'SupplierProject', // 中转路由
    targetRouterName: 'SupplierTaskCheck', // 目标路由
    needOrderId: true
  }, // 详情
})
